import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import Picture from "../../quarks/Picture";
import { borderWidth } from "./DeviceScreenMol.config";
import { Devices } from ".";
export var DeviceScreen = styled.div.withConfig({
  componentId: "sc-9fsnap-0"
})(function (_ref) {
  var theme = _ref.theme,
    $activeDevice = _ref.$activeDevice,
    $width = _ref.$width,
    $height = _ref.$height;
  return css(["position:relative;width:", ";max-width:100%;height:", ";overflow-y:auto;border:", " solid ", ";border-radius:", ";background:", ";box-shadow:", ";", "{width:", ";height:", ";border-radius:", ";}", "{width:", ";height:", ";border-radius:", ";}"], $width.large, $height.large, unit(borderWidth), getBorderColor(theme, "dark", "medium"), $activeDevice === Devices.DESKTOP ? space(2) : space(5), getColor(theme, "white"), getBoxShadow(theme, "small"), breakpoint("medium", "large"), $width.medium, $height.medium, $activeDevice === Devices.DESKTOP ? space(2) : space(4.5), breakpoint("small", "medium"), $width.small, $height.small, $activeDevice === Devices.DESKTOP ? space(0.5) : space(3));
});
export var IframeWrapper = styled.div.withConfig({
  componentId: "sc-9fsnap-1"
})(["width:100%;height:100%;overflow:hidden;"]);
export var StyledTemplateImageWrapper = styled.div.withConfig({
  componentId: "sc-9fsnap-2"
})(["width:100%;height:100%;overflow-y:scroll;"]);
export var StyledTemplateImage = styled(Picture).withConfig({
  componentId: "sc-9fsnap-3"
})(["width:100%;height:auto;"]);